// extracted by mini-css-extract-plugin
export default {"menuBlock":"KH-z","title":"LH-z","nav":"MH-z","flexCell":"NH-z","facetLink":"OH-z"};